import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
  Renderer2,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { REGEX } from '../helpers/regex';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: 'app-input',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormattedAmountDirective),
      multi: true,
    },
  ],
})
export class FormattedAmountDirective implements ControlValueAccessor {
  @Input() maxlength = 10;
  @Input() maxValue = 9999999999;

  lastValue: string;
  propagateChange = (_: any) => {};

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  input(value) {
    // const canonical = this.removeNonNumericCharacters(value);

    const canonical = this.validateNumnber(value);
    if (
      canonical.length > this.maxlength ||
      parseInt(canonical, 10) > this.maxValue
    ) {
      const lastValue = this.format(this.lastValue);
      this.render(lastValue);
      return;
    }
    const formatted = this.format(canonical);
    this.lastValue = canonical;
    this.render(formatted);

    this.propagateChange(canonical);
  }
  writeValue(value: any): void {
    if (!value && value !== 0) {
      return;
    }
    const canonical = this.validateNumnber(value.toString());
    const formatted = this.format(canonical);
    this.lastValue = canonical;
    this.render(formatted);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    const element = this.element.nativeElement.children[0];
    this.renderer.setProperty(element, 'disabled', isDisabled);
  }

  private removeNonNumericCharacters(value): string {
    return value.replace(REGEX.Digits, '');
  }

  private format(value): string {
    return value.toString().replace(REGEX.AddComma, '$1.');
  }

  private render(value) {
    const element = this.element.nativeElement.children[0];
    this.renderer.setProperty(element, 'value', value);
  }

  private validateNumnber(value: string) {
    const valid = /^\d{0,9}(\,\d{0,2})?$/.test(value);

    if (!valid) {
      const dotCheck = value.indexOf(',,');

      if (dotCheck >= 0) {
        value = value.replace(',,', ',');
      }

      value = value.replace('.', '');
      value = value.replace(/[^0-9,]/g, '');
      const totalLength = value.length;
      const only2DecimalsCount = value.indexOf(',');

      if (only2DecimalsCount >= 0 && totalLength > only2DecimalsCount + 2) {
        value = value.substring(0, only2DecimalsCount + 3);
      }
    }

    return value;
  }
}
